import { Grid, Typography, useTheme } from "@material-ui/core/";
import { GreenSwitch, IconButton } from '@coolremote/shared';
import { AccessTime } from "@material-ui/icons/";
import clsx from "clsx";
import _ from "lodash";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { PowerMeterItem, UnitItem } from "../";
import DesktopControlItem from "../../../../screens/Control/ControlComponents/ControlItem";
import { ArrowDownO } from "../../../../icons";
import { useStoreActions, useStoreState } from "../../../../models/RootStore";
import { SensorItem } from "../SensorItem";
import useStyle from "./GroupItem.style";
import { UnitItemNew } from "../UnitItemNew";
import { BiError } from 'react-icons/bi';
import { MdBatteryUnknown } from 'react-icons/md';
import { t } from "ttag";
import RedAlertBold from "@icons/RedAlertBold";
import { DisconnectIcon } from "@svgComponents";
import { getActiveSchedulesCount } from "../../../../utils/CommonUtils";

const ControlItem = (props: any) => {
  const { canControlSiteOperationStatus = true, openCollapse = true, addMessage, disableDragging, handleDragging, item, siteId, selectItem, hasSchedules, selectedItem, changeSitePower, onDragEnd, isCelsius, siteUiTemplates, siteParamTemplates, bacnetTemplatesLoading, allSchedules, allGroups } = props;
  const {
    id: itemId,
    isSensorGroup,
    name,
    units = [],
    sensors = [],
    schedules = [],
    powerMeters = [],
    itemsOrder = [],
    permissions = {},
    bacnetUnits = {},
  } = item;
  const { canControlOperationStatus } = permissions;
  const theme: any = useTheme();

  const [togglePowerButton, setTogglePowerButton] = useState<boolean>(false);
  const [targetPowerVal, setTargetPowerVal] = useState<any>(null);
  const [open, setOpen] = useState<boolean>((selectedItem?.firstTimeLoading && selectedItem.groupId === itemId) || false);
  const [groupStatus, setGroupStatus] = useState<any>({
    power: false,
    setPoint: null,
    mode: null
  });
  let spinnerTimer: number = 0;

  const types = useStoreState((state) => state);
  const groupPowerControl = useStoreActions((state) => state.groups.changePowerState);
  const allUnits = useStoreState((state) => state.units.allUnits);
  const setUnitsActiveOperationStatus = useStoreActions((state) => state.units.setUnitsActiveOperationStatus);
  const devices = useStoreState((state) => state.devices.allDevices);
  const allSensors = useStoreState((state) => state.sensors.allSensors);
  const allSensorGroups = useStoreState((state) => state.sensors.allSensorGroups);
  const getUnitsBy = useStoreState((state) => state.units.getUnitsBy);
  const allPowerMeters = useStoreState((state) => state.powerMeters.allPowerMeters);
  const {
    operationStatusesMirror: { on: powerOnVal }
  } = types;
  const [disablePowerBtn, setDisablePowerBtn] = useState<boolean>(false);

  const classes = useStyle();

  const sensorGroupObj = isSensorGroup && itemId && allSensorGroups[itemId];

  const sensorErrorValue = !!sensorGroupObj ?
    sensorGroupObj?.sensors.reduce((val: any, sensorId: any) => {
      if (val) {
        return val;
      }

      const sensorObj = allSensors[sensorId];
      if (!!sensorObj && +sensorObj?.type === 23) {
        return sensorObj?.readingValue;

      }
    }, null) :
    null;

  const sensorBatteryValue = !!sensorGroupObj ?
    sensorGroupObj?.sensors.reduce((val: any, sensorId: any) => {
      if (val) {
        return val;
      }

      const sensorObj = allSensors[sensorId];
      if (!!sensorObj && +sensorObj?.type === 22) {
        return sensorObj?.readingValue;
      }

      return null;
    }, null) :
    null;


  useEffect(() => {
    if (!openCollapse) {
      setOpen(true);
      return;
    }
  }, [openCollapse]);

  useEffect(() => {

    let oneAtleastIsConnected: boolean = false;
    for (let x in units) {
      const id = units[x];
      const unit: any = allUnits[id];

      if (!unit || !unit?.isConnected || !devices[unit?.device || ""]?.isConnected) {
        continue;
      }

      oneAtleastIsConnected = true;
    }

    if (!oneAtleastIsConnected) {
      for (let x in sensors) {
        const id = sensors[x];
        const sensor: any = allSensors[id];

        if (!sensor || !devices[sensor?.device || ""]?.isConnected) {
          continue;
        }
        if (sensor?.type === 129) {
          oneAtleastIsConnected = true;
        }
      }
    }
    setDisablePowerBtn(!oneAtleastIsConnected);
  }, [item, powerOnVal]);

  useEffect(() => {
    if (!togglePowerButton) {
      return;
    }
    if (
      groupStatus.power === targetPowerVal
    ) {
      setTogglePowerButton(false);
      clearTimeout(spinnerTimer);
    }
  }, [
    togglePowerButton,
    targetPowerVal,
    spinnerTimer,
    groupStatus
  ]);

  const switchClick = (event: any) => {
    event.stopPropagation();
    event.preventDefault();
  };

  const changeGroupPowerState = (event: any, powerOn: boolean) => {
    event.preventDefault();
    event.stopPropagation();
    const state = powerOn ? 1 : 2;

    setTargetPowerVal(powerOn);
    setTogglePowerButton(true);
    spinnerTimer = window.setTimeout(() => {
      setTogglePowerButton(false);
    }, 5000);

    const siteUnits = getUnitsBy("site", siteId, { type: "control" });
    const connectedUnits = units.filter((id: any) => {
      const unitObj = allUnits[id];
      if (!unitObj) {
        return false;
      }
      const isUnitConnected = unitObj?.isConnected;
      const isDeviceConnected = devices[unitObj?.device]?.isConnected;
      return isUnitConnected && isDeviceConnected;
    });

    itemId === "allUnits" ? (siteUnits.length === units?.length) ? changeSitePower({ state, siteId }) : setUnitsActiveOperationStatus({ units: connectedUnits, operationStatus: state }) : groupPowerControl({ groupId: itemId, state })
      .catch((error: any) => {
        addMessage({ message: error.message });
      });
  };

  const onUnitsCount = units.filter((id: any) => {
    const unitObj = allUnits[id];
    if (!unitObj) {
      return false;
    }

    const isUnitOn = unitObj?.activeOperationStatus === +powerOnVal;
    const isUnitConnected = unitObj?.isConnected;
    const isDeviceConnected = devices[unitObj?.device]?.isConnected;
    return isUnitOn && isUnitConnected && isDeviceConnected;
  }).length
    + sensors.filter((id: any) => {
      const sensor = allSensors[id];
      return sensor?.type === 129 && sensor?.readingValue === 1 && devices[sensor?.device]?.isConnected;
    }).length;

      const disconnectedUnitsCount = useMemo(
    () =>
      units.filter((id: any) => {
        const unitObj = allUnits[id];
        if (!unitObj) {
          return false;
        }
        const isUnitConnected = unitObj?.isConnected;
        const isDeviceConnected = devices[unitObj?.device]?.isConnected;
        return !isUnitConnected || !isDeviceConnected;
      }).length,
    [units, allUnits, devices]
  );

  const disconnectedSensorsCount = useMemo(
    () =>
      sensors.filter((id: any) => {
        const sensorObj: any = allSensors[id];
        if (!sensorObj) {
          return false;
        }
        return !devices[sensorObj?.device]?.isConnected;
      }).length,
    [sensors, allSensors, devices]
  );

  const disconnectedPowerMetersCount = useMemo(
    () =>
      powerMeters.filter(([id]: any) => {
        const pmObj = allPowerMeters[id];
        if (!pmObj) {
          return false;
        }
        return !pmObj.isConnected || !devices[pmObj.device]?.isConnected;
      }).length,
    [powerMeters, allPowerMeters, devices]
  );

  const totalDisconnectedCount =
    disconnectedUnitsCount + disconnectedSensorsCount + disconnectedPowerMetersCount;

  const isSelected = selectedItem.isGroup && selectedItem.groupId === itemId;

  const isAnyUnitInError = useMemo(() => 
    units?.some((unit: any) => {
      const message = allUnits?.[unit]?.message;
      return message && `${message}`.replace(/\s/g, '').toUpperCase() !== 'OK';
    }), 
    [units, allUnits]
  );

  return (
    <Fragment>
      <div
        {...handleDragging}
        className={clsx(classes.groupStyle, { [classes.selected]: isSelected })}
        onClick={() => (itemId === "sensors" || itemId === "bacnetUnits") ? {} : selectItem(siteId, { isGroup: true, groupId: itemId, unitId: "", type: "" })}
      >
        <IconButton onClick={(event: any) => { event.stopPropagation(); setOpen(!open); }} className={classes.iconHolder}>
          <ArrowDownO style={{ transform: open ? "unset" : "rotate(270deg)" }}
            fill={theme.palette.background.controlArrowDown || null} />
        </IconButton>
        <div className={classes.innerContainer}>
          <div className={classes.leftSection}>
            <div className={classes.topRow}>
              <Typography noWrap className={clsx(classes.nameStyle, { [classes.boldText]: selectedItem.isGroup && selectedItem.groupId === itemId })}>{name}</Typography>
            </div>
            <div className={classes.bottomRow}>
              {itemId !== "powerMeters" && !isSensorGroup && itemId !== "sensors" && units.length > 0 && (
                <Typography className={classes.unitsCount}>{onUnitsCount}/{units.length}</Typography>
              )}
            </div>
          </div>

          {!!sensorGroupObj &&
            <Grid className={clsx(classes.sensorGroupInfoSection)}>
              {sensorErrorValue !== null &&
                <div className={classes.sensorGroupInfoLine}>
                  <BiError style={{ fontSize: '18px' }} />
                  <Typography>
                    {t`Error:` + ` ${sensorErrorValue}`}
                  </Typography>
                </div>
              }
              {sensorBatteryValue !== null &&
                <div className={classes.sensorGroupInfoLine}>
                  <MdBatteryUnknown style={{ fontSize: '18px' }} />
                  <Typography>
                    {t`Battery:` + ` ${sensorBatteryValue}`}
                  </Typography>
                </div>
              }
            </Grid>}

          <div className={classes.rightSection}>
            {!!totalDisconnectedCount && (
              <Typography className={classes.disconnectedInfo}>
                <DisconnectIcon viewBox="0 3.43 24 17.14" width={31} height={22} />
              </Typography>
            )}
            {itemId !== "allUnits" && isAnyUnitInError && (
              <div className={classes.importantNoteSec}>
                <RedAlertBold width={22} height={22} />
              </div>
            )}
            {getActiveSchedulesCount(schedules, allSchedules) > 0 && <AccessTime className={classes.noteIcon} />}
            {itemId !== "powerMeters" && !isSensorGroup && itemId !== "sensors" && units.length > 0 && (
              <GreenSwitch
                checked={onUnitsCount > 0}
                disableRipple={true}
                onClick={(e: any) => (itemId === "allUnits" ? canControlSiteOperationStatus : canControlOperationStatus) && switchClick(e)}
                switchChange={(e: any) => (itemId === "allUnits" ? canControlSiteOperationStatus : canControlOperationStatus) && changeGroupPowerState(e, !(onUnitsCount > 0))}
                value="checkedA"
                disabled={disablePowerBtn || (itemId === "allUnits" ? !canControlSiteOperationStatus : !canControlOperationStatus)}
                color={theme.palette.colors?.switchPower?.colorChecked || theme.palette.colors?.switch?.colorChecked}
                uncheckedColor={theme.palette.colors?.switchPower?.color || theme.palette.colors?.switch?.color}
              />
            )}
          </div>
        </div>
      </div>
      <DragDropContext onDragEnd={(result: any) => onDragEnd(result)(itemId)}>
        <Droppable droppableId="list">
          {(provided: any) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {open &&
                itemsOrder.map((item: any, index: number) => {
                  const [id, show, type = "unit"] = item;
                  if (!show) {
                    return null;
                  }
                  if (allUnits[id]) {
                    return (
                      <Draggable isDragDisabled={disableDragging} key={`group-${itemId}-unit-${id}`} draggableId={id} index={index}>
                        {(provided: any) => (
                          <div ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}>
                            <UnitItemNew addMessage={addMessage} key={`u-group-${itemId}-unitNew-${id}`} selectedItem={selectedItem} unitId={id} siteId={siteId} selectItem={selectItem} groupId={itemId} hasSchedules={true} allSchedules={allSchedules} allGroups={allGroups} />
                          </div>)}
                      </Draggable>
                    );
                  }
                  if (allSensors[id] && allSensors[id].isVisible) {
                    return (
                      <Draggable isDragDisabled={disableDragging} key={`group-${itemId}-sensor-${id}`} draggableId={id} index={index}>
                        {(provided: any) => (
                          <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <SensorItem selectedItem={selectedItem} sensorId={id} siteId={siteId} selectItem={selectItem} groupId={itemId} isCelsius={isCelsius} allSchedules={allSchedules} />
                          </div>)}
                      </Draggable>
                    );
                  }
                  if (bacnetUnits[id]) {
                    return (
                      <Draggable isDragDisabled={disableDragging} key={`group-${itemId}-bacnet-${id}`} draggableId={id} index={index}>
                        {(provided: any) => (
                          <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <DesktopControlItem
                              type="bacnetUnit"
                              entry={bacnetUnits[id]}
                              selectedItem={selectedItem}
                              siteId={siteId}
                              selectItem={selectItem}
                              groupId={itemId}
                              siteUiTemplates={siteUiTemplates}
                              siteParamTemplates={siteParamTemplates}
                              bacnetTemplatesLoading={bacnetTemplatesLoading}
                              allSchedules={allSchedules}
                            />
                          </div>)}
                      </Draggable>
                    );
                  }
                  return null;
                })
              }
              {open && !_.isEmpty(powerMeters) && powerMeters.map((powerMeter: any) =>
                !powerMeter[1] ? null : <PowerMeterItem key={`group-${itemId}-powerMeter-${powerMeter[0]}`} id={powerMeter[0]} selectedItem={selectedItem} siteId={siteId} selectItem={selectItem} groupId={itemId} />
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Fragment>
  );

};

export default ControlItem;
